import { render, staticRenderFns } from "./ISAStatcallsUnansweredCount.vue?vue&type=template&id=65a6017e&scoped=true&"
import script from "./ISAStatcallsUnansweredCount.vue?vue&type=script&lang=js&"
export * from "./ISAStatcallsUnansweredCount.vue?vue&type=script&lang=js&"
import style0 from "./ISAStatcallsUnansweredCount.vue?vue&type=style&index=0&id=65a6017e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6017e",
  null
  
)

export default component.exports